import React, { useEffect, useState } from 'react';
import './styles.css';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';
import regionConfig from '../../config/regionConfig';
import { useTranslation } from 'react-i18next';

const libraries = ['places', 'geometry'];

const Map = ({ latitudeEmpresa, longitudeEmpresa, setLatitudeEmpresa, setLongitudeEmpresa }) => {
    const { t } = useTranslation(['common', 'storeInfo']);
    const ApiKey = process.env.REACT_APP_GOOGLE_API_KEY;

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        libraries: libraries,
        googleMapsApiKey: ApiKey,
        language: regionConfig.map.language,
        region: regionConfig.map.googleRegion,
    });

    const mapContainerStyle = {
        height: "400px",
        width: "100%",
    };

    // Garantir que as coordenadas sejam válidas antes de criar o estado
    const [markerPosition, setMarkerPosition] = useState({
        lat: latitudeEmpresa || regionConfig.map.defaultLat,
        lng: longitudeEmpresa || regionConfig.map.defaultLng,
    });

    // Atualizar posição do marcador quando as coordenadas props mudarem
    useEffect(() => {
        if (latitudeEmpresa && longitudeEmpresa) {
            setMarkerPosition({
                lat: latitudeEmpresa,
                lng: longitudeEmpresa,
            });
        }
    }, [latitudeEmpresa, longitudeEmpresa]);

    const center = {
        lat: markerPosition.lat,
        lng: markerPosition.lng,
    };



    const onLoad = (circle) => {
        // process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Circle onLoad circle: ', circle)
    };

    const onUnmount = (circle) => {
        // process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Circle onUnmount circle: ', circle)
    };

    const handleMarkerDragEnd = (event) => {
        const newLat = event.latLng.lat();
        const newLng = event.latLng.lng();
        
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Nova posição definida:', { latitude: newLat, longitude: newLng });
        
        setMarkerPosition({ lat: newLat, lng: newLng });
        setLatitudeEmpresa(newLat);
        setLongitudeEmpresa(newLng);
        
        // Não salvar no banco aqui - isso será feito pelo botão "Salvar e Continuar"
        process.env.REACT_APP_ISDEVELOP === 'true' && console.log('Posição atualizada no estado. Clique em "Salvar e Continuar" para persistir no banco.');
    };



    // Não renderizar se não tiver coordenadas válidas
    if (!latitudeEmpresa || !longitudeEmpresa) {
        return (
            <div className='mapContainer'>
                <div style={{ 
                    height: '400px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    background: '#f8fafc',
                    border: '2px dashed #cbd5e1',
                    borderRadius: '8px',
                    color: '#64748b'
                }}>
                    <p>{t('map.awaitingLocation')}</p>
                </div>
            </div>
        );
    }

    return (
        <div className='mapContainer'>
            {
                isLoaded ? (                   
                    <GoogleMap
                        mapContainerStyle={mapContainerStyle}
                        center={center}
                        zoom={14}
                        onLoad={onLoad}
                        onUnmount={onUnmount}
                        options={{
                            className: 'custom-map',
                        }}
                    >
                        <Marker
                            position={markerPosition}
                            options={{
                                label: {
                                    text: t('storeInfo:myEstablishment'),
                                    className: "mapMarker"
                                },
                                draggable: true,
                            }}
                            onDragEnd={handleMarkerDragEnd}
                        />                    
                    </GoogleMap>
                ) : (
                    <div style={{ 
                        height: '400px', 
                        display: 'flex', 
                        alignItems: 'center', 
                        justifyContent: 'center',
                        background: '#f8fafc',
                        borderRadius: '8px',
                        color: '#64748b'
                    }}>
                        <p>{t('common:map.loadingMap')}</p>
                    </div>
                )
            }
        </div>
    );
};

export default Map;
